import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import shoorahLogo from '../../../assets/images/shoorah-logo.jpg';
import { on } from 'ws';
import { horizontalListCardData as cardData } from '../../../utils/pageContent';

const HorizontalListCard = ({ title, onViewAllTap, dataList, onDropDownSelect }) => {
  const navigate = useNavigate();

  const [isShowDropdown, setIsShowDropdown] = useState(false);
  const [assessmentId, setAssessmentId] = useState(null);
  const dropdownRef = useRef(null);

  // useEffect(() => {
  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);
  // const handleClickOutside = (event) => {
  //   if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //     setIsShowDropdown(false);
  //   }
  // };

  return (
    <div className="bg-white border-[1.5px] border-shoorah-borderGray rounded-[16px] mt-5 mb-[18px] px-5 md:px-6 pt-6 pb-8 dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
      <div className="horizontal-card-header grid grid-cols-12 mb-[27px] items-center">
        <div className="sm:col-span-7 col-span-9">
          <p className="sm:text-2xl text-[14px] leading-9 font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
            {title}
          </p>
        </div>
        <div className="sm:col-span-5 col-span-3">
          <button
            className="sm:text-[14px] text-[12px] text-shoorah-active ms-auto w-full text-right text-nowrap"
            onClick={onViewAllTap}
          >
            {cardData.viewAllBtnText}
          </button>
        </div>
      </div>
      <div className="horizontal-card-body flex gap-[19px] overflow-x-auto horizontal-card-scrollbar pb-[30px]">
        {dataList?.length === 0 ? (
          <div className="flex justify-center items-center h-full w-full">
            <p className="text-[20px] text-shoorah-customGray">{cardData.noDataAvailableText}</p>
          </div>
        ) : (
          dataList?.slice(0, 5)?.map((data, index) => (
            <div
              key={index}
              className="card-content grid grid-cols-12 border-[1.5px] border-shoorah-borderGray rounded-2xl p-5 w-full sm:max-w-[450px] min-w-[450px] h-[218px] gap-[28px] flex-shrink-0 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder"
            >
              <div className="img-box col-span-6 rounded-xl w-[178px] max-h-[178px]">
                <img
                  src={data?.coverImage ? data?.coverImage : shoorahLogo}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = shoorahLogo;
                  }}
                  alt="Template"
                  className="w-full h-full object-cover object-center rounded-xl"
                />
              </div>
              <div className="content-box col-span-6 h-full">
                <div className="dropdown-menu text-right relative" ref={dropdownRef}>
                  <button
                    onClick={() => [setIsShowDropdown(!isShowDropdown), setAssessmentId(data?.id)]}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="dark:invert"
                    >
                      <path
                        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                        stroke="#0B1D2E"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                        stroke="#0B1D2E"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                        stroke="#0B1D2E"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  {isShowDropdown && assessmentId === data?.id && (
                    <ul className="w-auto h-fit overflow-y-auto rounded-xl z-10 bg-[#FFFFFF] border border-shoorah-borderGray ms-auto absolute top-full right-0 dark:text-shoorah-darkBg dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
                      <li
                        className="pl-4 pr-6 py-2 hover:bg-shoorah-borderGray hover:dark:text-shoorah-darkBgColor cursor-pointer text-left capitalize"
                        onClick={() => {
                          onDropDownSelect(2, data?.id);
                          setIsShowDropdown(false);
                        }}
                      >
                        {cardData.editBtnText}
                      </li>
                      <li
                        className="pl-4 pr-6 py-2 hover:bg-shoorah-borderGray hover:dark:text-shoorah-darkBgColor cursor-pointer text-left capitalize"
                        onClick={() => {
                          onDropDownSelect(0, data?.id);
                          setIsShowDropdown(false);
                        }}
                      >
                        {cardData.viewBtnText}
                      </li>
                      <li
                        className="pl-4 pr-6 py-2 hover:bg-shoorah-borderGray hover:dark:text-shoorah-darkBgColor cursor-pointer text-left capitalize"
                        onClick={() => {
                          onDropDownSelect(1, data?.id);
                          setIsShowDropdown(false);
                        }}
                      >
                        {cardData.deleteBtnText}
                      </li>
                    </ul>
                  )}
                </div>
                <p className="text-xl leading-6 text-[#000000] font-bold whitespace-normal dark:text-shoorah-darkBg">
                  {data?.title?.slice(0, 25)}
                </p>
                <p className="text-[16px] text-[#000000] leading-5 mt-[14px] dark:text-shoorah-darkBg">
                  {cardData.usedText} {data?.usedBy || 0} {cardData.timesText}
                </p>
                <button
                  className="btn-primary btn-sm w-[108px] mt-[17px] self-start"
                >
                  {data?.type === 1 ? cardData.attachmentBtnText : cardData.percentageBtnText}
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default HorizontalListCard;
